module.exports = __webpack_public_path__ + "img/Perdues@2x.19625a2c.webp";